(ns basic-components.modal
  (:require
   [ui.components.modal.view :as modal]))


(defonce modal-key :zap-modal-key)
(defn view
  [{:keys [shown? close-modal! props state class-name topmost?]}]
  (let [{:keys [title
                footer
                content
                size
                color
                no-close-button?
                variant]}
        props]
    [modal/view
     {:visible?      (and shown? topmost?)
      :hide!         close-modal!
      :backdrop      "static"
      :size          size
      :variant       variant
      :color         color
      :close-button? (not no-close-button?)}
     title
     (cond (fn? content)
           [content close-modal!]
           content
           content
           :else
           "")
     (if (fn? footer)
       (footer close-modal!)
       footer)]))
